module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"An error occurred!":"Es ist ein Fehler aufgetreten!","Payment method could not be saved.":"Zahlungsart konnte nicht gespeichert werden."}}')
  delete Component.options._Ctor
}
